module.exports = __webpack_public_path__ + "img/icon-christmas-10.63d7a84f.svg";